import React from "react";
import { Routes, Route } from "react-router-dom";
import AdminLayout from "./layouts/AdminLayout";
import AdminUsers from "./users/pages/AdminUsers";
import AdminSellers from "./sellers/AdminSellers";
import AdminProducts from "./products/AdminProducts";
import AdminCategoryProducts from "./products/AdminProductCategories";
export default function AdminRoutes() {
  return (
    <AdminLayout>
      <Routes>
        <Route path="users" element={<AdminUsers />} />
        <Route path="sellers" element={<AdminSellers />} />
        <Route path="products" element={<AdminProducts />} />
        <Route
          path="products/category/:categoryId"
          element={<AdminCategoryProducts />}
        />
      </Routes>
    </AdminLayout>
  );
}
